var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-basic p-home"},[_c('div',{staticClass:"cont",domProps:{"textContent":_vm._s(_vm.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }